import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MessagingActivityUnreadCountQueryVariables = Types.Exact<{
  types?: Types.InputMaybe<Array<Types.MessagingActivityItemType> | Types.MessagingActivityItemType>;
}>;


export type MessagingActivityUnreadCountQuery = { __typename?: 'Query', MessagingActivityItems: { __typename?: 'MessagingActivityItems', totalCount: number } };


export const MessagingActivityUnreadCountDocument = gql`
    query MessagingActivityUnreadCount($types: [MessagingActivityItemType!]) {
  MessagingActivityItems(
    filters: {read: false, types: $types, excludePostsCopiedToChats: {value: true}}
  ) {
    totalCount
  }
}
    `;

/**
 * __useMessagingActivityUnreadCountQuery__
 *
 * To run a query within a React component, call `useMessagingActivityUnreadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagingActivityUnreadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagingActivityUnreadCountQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useMessagingActivityUnreadCountQuery(baseOptions?: Apollo.QueryHookOptions<MessagingActivityUnreadCountQuery, MessagingActivityUnreadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagingActivityUnreadCountQuery, MessagingActivityUnreadCountQueryVariables>(MessagingActivityUnreadCountDocument, options);
      }
export function useMessagingActivityUnreadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagingActivityUnreadCountQuery, MessagingActivityUnreadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagingActivityUnreadCountQuery, MessagingActivityUnreadCountQueryVariables>(MessagingActivityUnreadCountDocument, options);
        }
export type MessagingActivityUnreadCountQueryHookResult = ReturnType<typeof useMessagingActivityUnreadCountQuery>;
export type MessagingActivityUnreadCountLazyQueryHookResult = ReturnType<typeof useMessagingActivityUnreadCountLazyQuery>;
export type MessagingActivityUnreadCountQueryResult = Apollo.QueryResult<MessagingActivityUnreadCountQuery, MessagingActivityUnreadCountQueryVariables>;